import React, { useEffect } from 'react';
import { Box, Typography, Breadcrumbs, Divider, Card, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

// import { useResponseHandler } from '../../../../hooks/useResponseHandler';
import { formInitialValues } from './formik/formInitialValues';
import { validationSchema } from './formik/validationSchema';
import { ajustesGlobalesIaFormModel } from './formik/ajustesGlobalesIaFormModel';
import { AjustesGlobalesIaForm } from './components/forms/AjustesGlobalesIaForm';
// import { createGlobalConfigStore, getApplicationDataDropDownStore } from '../../../../store/services-ia-global-config';
import { useResponseHandler } from 'hooks/useResponseHandler';
import { getApplicationDataDropDownStore } from 'store/app-releases';
import { createGlobalConfigStore, getDataFormDropDownStore } from 'store/services-ia-global-config';

export const CreateAjustesGlobalesIa = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { handleResponse, ResponseComponents } = useResponseHandler();
    const { formId, formField } = ajustesGlobalesIaFormModel;
    const [dataErrors, setMsgErrors] = React.useState([]);

 
    useEffect(() => {
        getDataForm();
    }, []); 

    const getDataForm = async()=>{
        const data = await dispatch(getDataFormDropDownStore());
    }

    useEffect(() => {
        getDataForm();
    }, []);

    const handleSubmit = async (values: any, actions: any) => {
        actions.setSubmitting(true);
        
        // Formato para enviar al backend: los selects vienen como objeto { value, label } si se usa Autocomplete
        const mappedValues = {
            ...values,
            defaultChatServiceId: values.defaultChatServiceId?.value || values.defaultChatServiceId || null,
            defaultImageServiceId: values.defaultImageServiceId?.value || values.defaultImageServiceId || null,
            defaultAudioServiceId: values.defaultAudioServiceId?.value || values.defaultAudioServiceId || null,
            defaultEmbeddingServiceId: values.defaultEmbeddingServiceId?.value || values.defaultEmbeddingServiceId || null,
            defaultOcrServiceId: values.defaultOcrServiceId?.value || values.defaultOcrServiceId || null,
        };

        const response = await dispatch(createGlobalConfigStore(mappedValues));
        await handleResponse(response, 'Configuración Global Creada Con Éxito', true);
        actions.setSubmitting(false);

        if(response.ok){
            actions.resetForm();
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            {ResponseComponents}

            <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>Crear Configuración Global de IA</Typography>
            <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
                <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Manager</Typography>
                <Link color="inherit" to="/manager/plataforma-ia/configuracion/ajustes">
                    Configuración Global
                </Link>
                <Typography color="textPrimary">Crear</Typography>
            </Breadcrumbs>
            
            <Divider sx={{ marginBottom: 3 }}/>

            <Formik
                initialValues={formInitialValues}
                validationSchema={validationSchema[0]}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting }) => (
                    <Card sx={{ mt: 2, p: 3, borderRadius: 2, boxShadow: '0px 12px 24px -4px rgba(145, 158, 171, 0.12)' }}>
                        <Form id={formId} autoComplete="off">
                            <AjustesGlobalesIaForm formField={formField} />

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
                                <Button 
                                    component={Link}
                                    to="/manager/plataforma-ia/configuracion/ajustes"
                                    color="inherit" 
                                    sx={{ borderRadius: 2, textTransform: 'none' }}
                                >
                                    Cancelar
                                </Button>
                                <Button 
                                    type="submit" 
                                    variant="contained" 
                                    color="primary"
                                    disabled={isSubmitting}
                                    sx={{ borderRadius: 2, textTransform: 'none' }}
                                >
                                    {isSubmitting ? 'Guardando...' : 'Guardar Configuración'}
                                </Button>
                            </Box>
                        </Form>
                    </Card>
                )}
            </Formik>
        </Box>
    );
};
